import _ from 'lodash';
import bdaVisitService from '@/services/bdaVisitService';
import BdaVisit from '../../model/bdaVisit';

const state = {
  baseUrl: '/bda-visit',
  pagination: {},
  bdaVisits: [],
  loading: false,
  bdaVisit: null,
  bdaVisitsDownload: []
};

const actions = {
  uploadImage({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file } = query;
    bdaVisitService
      .getSignedUrl({ filename: file.name, filetype: file.type, file })
      .then(response => {
        bdaVisitService
          .uploadImage({ url: response.data, file })
          .then(res => {
            commit('Nothing', res);
          })
          .catch(e => {
            commit('requestFailed');
            dispatch('common/handleServiceException', { e, router }, { root: true });
          });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  listBdaVisits({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setBdaVisits', { bdaVisits: [], pagination: {} });

    commit('startRequest');

    bdaVisitService
      .listBdaVisits({ query })
      .then(response => {
        commit('setBdaVisits', { bdaVisits: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { bdaVisit, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    bdaVisitService
      .postOne({ bdaVisit })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'New BDA Visit has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setBdaVisit', { bdaVisit: {} });

    bdaVisitService
      .getOne({ id })
      .then(response => {
        commit('setBdaVisit', { bdaVisit: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { id, bdaVisit, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    bdaVisitService
      .patchOne({ id, newBdaVisit: bdaVisit })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'BDA Visit has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    bdaVisitService
      .deleteOne({ id })
      .then(_response => {
        dispatch('listBdaVisits', { id });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: ' BDA Visit has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  downloadBdaVisits({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    bdaVisitService
      .listBdaVisits({ query })
      .then(response => {
        commit('setBdaVisitsDownload', {
          bdaVisitsDownload: response.data.rows
        });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setBdaVisits(state, { bdaVisits, pagination }) {
    state.bdaVisits = _.map(bdaVisits, (bdaVisit, index) => {
      const newBdaVisits = new BdaVisit({
        index,
        id: bdaVisit._id, // eslint-disable-line
        shopOwnerName: bdaVisit.shopOwnerName,
        retailerName: bdaVisit.retailerName,
        retailerMobile: bdaVisit.retailerMobile,
        retailerAddress: bdaVisit.retailerAddress,
        pinCode: bdaVisit.pinCode,
        storeId: bdaVisit.storeId,
        storeName: bdaVisit.storeName,
        shopImage: bdaVisit.shopImage,
        lat: bdaVisit.lat,
        long: bdaVisit.long,
        submittedByBda: bdaVisit.submittedByBda,
        submittedByBdaName: bdaVisit.submittedByBdaName,
        createdAt: bdaVisit.createdAt
      });
      return newBdaVisits;
    });
    state.pagination = pagination;
    state.loading = false;
  },
  setBdaVisitsDownload(state, { bdaVisitsDownload }) {
    state.bdaVisitsDownload = _.map(bdaVisitsDownload, (bdaVisit, index) => {
      const newBdaVisits = new BdaVisit({
        index,
        id: bdaVisit._id, // eslint-disable-line
        shopOwnerName: bdaVisit.shopOwnerName,
        retailerName: bdaVisit.retailerName,
        retailerMobile: bdaVisit.retailerMobile,
        retailerAddress: bdaVisit.retailerAddress,
        pinCode: bdaVisit.pinCode,
        storeId: bdaVisit.storeId,
        storeName: bdaVisit.storeName,
        shopImage: bdaVisit.shopImage,
        lat: bdaVisit.lat,
        long: bdaVisit.long,
        submittedByBda: bdaVisit.submittedByBda,
        submittedByBdaName: bdaVisit.submittedByBdaName,
        createdAt: bdaVisit.createdAt
      });
      return newBdaVisits;
    });
    state.loading = false;
  },
  setBdaVisit(state, { bdaVisit }) {
    state.bdaVisit = new BdaVisit({
      id: bdaVisit._id, // eslint-disable-line
      shopOwnerName: bdaVisit.shopOwnerName,
      retailerName: bdaVisit.retailerName,
      retailerMobile: bdaVisit.retailerMobile,
      retailerAddress: bdaVisit.retailerAddress,
      pinCode: bdaVisit.pinCode,
      storeId: bdaVisit.storeId,
      storeName: bdaVisit.storeName,
      shopImage: bdaVisit.shopImage,
      lat: bdaVisit.lat,
      long: bdaVisit.long,
      submittedByBda: bdaVisit.submittedByBda,
      submittedByBdaName: bdaVisit.submittedByBdaName,
      createdAt: bdaVisit.createdAt
    });
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
